<template>
    <div>
      <h2>Modifier l'info</h2>
      <div class="add-association">
        <form @submit.prevent="submitForm">
          <label>Nom :</label>
          <input type="text" v-model="form.name" required />

          <label>Fichier info : (laisser vide pour ne pas changer) </label>
          <input type="file" @change="handleImage" accept=".pdf" />
        
          <button type="submit">Enregistrer</button>
          <button type="button" @click="$emit('close')">Annuler</button>
        </form>
      </div>
    </div>
  </template>
  <script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'EditInfoForm',
    props: { info: { type: Object, required: true } },
    data() {
      return {
        file: this.info.file,
        form: {
          id: this.info.id,
          name: this.info.name,
        },
      };
    },
    computed: {
      ...mapGetters(['getInfos']),
    },
    mounted() {
    },
    methods: {
      handleImage(e) { this.file = e.target.files[0]; },
      submitForm() {
        const formData = new FormData(); if (this.file) formData.append('file', this.file);
        const payload = { id:this.form.id, name:this.form.name};
        formData.append('infoUpdate', JSON.stringify(payload));
        this.$store.dispatch('updateInfo', formData).then(()=>this.$emit('close'));
      }
    },
    created() {
    }
  };
  </script>
  <style scoped>
  .add-association{background-color:#F8F8FF;border-radius:10px;padding:2rem;border:1px solid #ccc;text-align:left}
  form{display:flex;flex-direction:column}
  label{font-weight:bold;margin-top:1rem;margin-bottom:.25rem;color:#5E3B80}
  input[type="text"],input[type="number"],textarea,.ql-container{padding:.5rem;border:1px solid #ccc;border-radius:6px;font-size:1rem;width:100%}
  textarea,.text-editor{min-height:150px;resize:vertical;overflow-y:auto}
  .ql-container{min-height:150px}
  .checkbox-group{display:flex;flex-direction:column;gap:.5rem;margin-top:.5rem}
  .checkbox-group label{margin-left:.5rem;font-weight:normal;color:#333}
  button{margin-top:2rem;background-color:#167580;color:white;border:none;padding:.75rem;font-weight:bold;border-radius:8px;cursor:pointer;transition:background-color .2s}
  button:hover{background-color:#1E1C66}
  </style>
  